import {Controller} from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["overlay", "card", "title", "definition", "closeButton"]
  }

  connect() {
    this._boundHandleDocumentClick = this._handleDocumentClick.bind(this)
    this._boundHandleDocumentKeydown = this._handleDocumentKeydown.bind(this)
    this._triggerElement = null

    document.addEventListener("click", this._boundHandleDocumentClick)
    document.addEventListener("keydown", this._boundHandleDocumentKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this._boundHandleDocumentClick)
    document.removeEventListener("keydown", this._boundHandleDocumentKeydown)
  }

  close() {
    if (!this._isOpen()) return

    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("fwa-vocab-modal-visible")
    document.body.style.overflow = ""

    if (this._triggerElement && this._triggerElement.focus) {
      this._triggerElement.focus()
    }
    this._triggerElement = null
  }

  backdropClick(event) {
    if (this.hasCardTarget && !this.cardTarget.contains(event.target)) {
      this.close()
    }
  }

  _handleDocumentClick(event) {
    const trigger = event.target.closest(".fwa-vocab-term")
    if (!trigger) return
    this._openFromTrigger(trigger, event)
  }

  _handleDocumentKeydown(event) {
    if (this._isOpen()) {
      if (event.key === "Escape") {
        event.preventDefault()
        this.close()
        return
      }

      if (event.key === "Tab") {
        this._handleTabTrap(event)
      }
      return
    }

    const trigger = event.target.closest(".fwa-vocab-term")
    if (!trigger) return

    if (event.key === "Enter" || event.key === " ") {
      this._openFromTrigger(trigger, event)
    }
  }

  _openFromTrigger(trigger, event) {
    if (!trigger) return

    const definition = trigger.getAttribute("data-definition")
    if (!definition) return

    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    const term = trigger.getAttribute("data-term") || trigger.textContent.trim()
    this._triggerElement = trigger
    this._show(term, definition)
  }

  _show(term, definition) {
    this.titleTarget.textContent = term
    this.definitionTarget.textContent = definition

    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("fwa-vocab-modal-visible")
    document.body.style.overflow = "hidden"

    requestAnimationFrame(() => {
      if (this.hasCloseButtonTarget) {
        this.closeButtonTarget.focus()
      } else {
        this._trapFocus()
      }
    })
  }

  _isOpen() {
    return this.hasOverlayTarget && !this.overlayTarget.classList.contains("hidden")
  }

  _trapFocus() {
    const focusable = this._getFocusableElements()
    if (focusable.length > 0) {
      focusable[0].focus()
    }
  }

  _getFocusableElements() {
    if (!this.hasCardTarget) return []
    return Array.from(
      this.cardTarget.querySelectorAll(
        'button:not([disabled]):not([hidden]), [href]:not([hidden]), input:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])'
      )
    ).filter((el) => el.offsetParent !== null)
  }

  _handleTabTrap(event) {
    const focusable = this._getFocusableElements()
    if (focusable.length === 0) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault()
        last.focus()
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }
  }
}
